(() => {
  const story = document.querySelector('[data-scroll-story]');
  if (!story) return;

  const overlay = story.querySelector('[data-scroll-story-overlay]')
    || document.querySelector('[data-scroll-story-overlay]');
  const stage = story.querySelector('.scroll-story__stage');
  const track = story.querySelector('.scroll-story__track');
  const linesSvg = overlay?.querySelector('[data-scroll-lines]');
  const linesGroup = overlay?.querySelector('[data-scroll-lines-group]');
  const callouts = overlay ? [...overlay.querySelectorAll('[data-callout]')] : [];
  const copyCta = overlay?.querySelector('[data-scroll-story-cta]');

  function ensureOverlayPinned() {
    const pin = document.querySelector('.hero-v2-can-pin');
    if (!pin || !overlay || overlay.dataset.pinned) return;
    overlay.classList.add('scroll-story__overlay--pinned');
    overlay.dataset.pinned = 'true';
    story.classList.add('has-pinned-overlay');
    pin.appendChild(overlay);
  }

  ensureOverlayPinned();

  // Scrub configuration: each callout reveals inside its own window of the
  // overall scroll progress so they cascade in (and back out) with scroll.
  const CALLOUT_SPREAD = 0.55; // last callout starts at this progress
  const CALLOUT_WIDTH = 0.45;  // progress distance each callout takes to fully reveal
  const EYEBROW_END = 0.35;
  const COPY_START = 0.6;
  const REVEAL_PORTION = 0.75; // fraction of leftover track scroll used for the scrub
  const INTERACTIVE_AT = 0.65;

  let progress = 0;
  let interactive = false;
  let lineEls = [];
  let rafId = null;
  let floatT = 0;
  let lastTs = 0;
  const magnets = callouts.map(() => ({ x: 0, y: 0 }));
  const reveals = callouts.map(() => 0);

  story.classList.add('is-scrub');
  overlay?.classList.add('is-scrub');

  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  function calloutReveal(i) {
    const n = Math.max(1, callouts.length - 1);
    const start = (i / n) * CALLOUT_SPREAD;
    return easeOutCubic(clamp01((progress - start) / CALLOUT_WIDTH));
  }

  function ensureLines() {
    if (!linesGroup || lineEls.length === callouts.length) return;
    linesGroup.innerHTML = '';
    lineEls = callouts.map((_, i) => {
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('class', 'scroll-story__line');
      line.style.setProperty('--line-i', String(i));
      linesGroup.appendChild(line);
      return line;
    });
  }

  function measureBox() {
    if (overlay) return overlay.getBoundingClientRect();
    if (stage) return stage.getBoundingClientRect();
    return story.getBoundingClientRect();
  }

  function hubPoint() {
    const sr = measureBox();
    const hx = parseFloat(overlay?.dataset.hubX || '50');
    const hy = parseFloat(overlay?.dataset.hubY || '42');
    return {
      x: sr.left + (hx / 100) * sr.width,
      y: sr.top + (hy / 100) * sr.height,
    };
  }

  function labelAttachPoint(hub, rect) {
    const cx = rect.left + rect.width * 0.5;
    const cy = rect.top + rect.height * 0.5;
    const dx = cx - hub.x;
    const dy = cy - hub.y;
    if (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001) return { x: cx, y: cy };
    const hw = rect.width * 0.5;
    const hh = rect.height * 0.5;
    const scale = 1 / Math.max(Math.abs(dx) / hw, Math.abs(dy) / hh);
    return { x: cx - dx * scale, y: cy - dy * scale };
  }

  function updateLines() {
    if (!linesSvg || !lineEls.length) return;

    const svgRect = linesSvg.getBoundingClientRect();
    linesSvg.setAttribute('viewBox', `0 0 ${svgRect.width || 1} ${svgRect.height || 1}`);

    const hub = hubPoint();

    callouts.forEach((el, i) => {
      const label = el.querySelector('.scroll-story__callout-label');
      const line = lineEls[i];
      if (!label || !line) return;

      const attach = labelAttachPoint(hub, label.getBoundingClientRect());

      const x1 = hub.x - svgRect.left;
      const y1 = hub.y - svgRect.top;
      const x2 = attach.x - svgRect.left;
      const y2 = attach.y - svgRect.top;

      line.setAttribute('x1', x1.toFixed(2));
      line.setAttribute('y1', y1.toFixed(2));
      line.setAttribute('x2', x2.toFixed(2));
      line.setAttribute('y2', y2.toFixed(2));

      const len = Math.hypot(x2 - x1, y2 - y1);
      const t = reveals[i];
      line.style.strokeDasharray = `${len.toFixed(2)}`;
      line.style.strokeDashoffset = (len * (1 - t)).toFixed(2);
      line.style.opacity = clamp01(t * 2.5).toFixed(3);
    });
  }

  function applyFloat() {
    callouts.forEach((el, i) => {
      const fx = Math.sin(floatT * 0.9 + i * 1.35) * 5;
      const fy = Math.cos(floatT * 0.72 + i * 1.05) * 6;
      el.style.setProperty('--float-x', `${fx.toFixed(2)}px`);
      el.style.setProperty('--float-y', `${fy.toFixed(2)}px`);
      el.style.setProperty('--magnet-x', `${magnets[i].x.toFixed(2)}px`);
      el.style.setProperty('--magnet-y', `${magnets[i].y.toFixed(2)}px`);
    });
  }

  function tick(ts) {
    if (progress <= 0) {
      rafId = null;
      lastTs = 0;
      return;
    }
    const dt = lastTs ? Math.min(0.05, (ts - lastTs) / 1000) : 0.016;
    lastTs = ts;
    floatT += dt;

    applyFloat();
    updateLines();
    rafId = requestAnimationFrame(tick);
  }

  function startTicking() {
    if (rafId) return;
    lastTs = 0;
    rafId = requestAnimationFrame(tick);
  }

  // Scroll progress for the callout scrub: 0 when the can settles into the
  // story section, 1 after scrolling REVEAL_PORTION of the leftover track.
  function readScrub() {
    const hero = document.querySelector('[data-hero-carousel]');
    const settleEl = document.getElementById('stack-hero-3d-settle');
    if (!hero || !settleEl) return 0;

    let settle;
    try {
      settle = JSON.parse(settleEl.textContent);
    } catch (_) {
      return 0;
    }

    const heroRect = hero.getBoundingClientRect();
    const storyRect = story.getBoundingClientRect();
    const heroBottomDoc = window.scrollY + heroRect.bottom;
    const storyTopDoc = window.scrollY + storyRect.top;

    const start = heroBottomDoc - window.innerHeight * (settle.handoffStartVh ?? 0.7);
    const end = storyTopDoc + window.innerHeight * (settle.handoffEndVh ?? 0);
    const range = Math.max(window.innerHeight * 0.9, end - start);
    const settleY = start + range;

    const trackH = track ? track.offsetHeight : window.innerHeight * 2;
    const dist = Math.max(
      window.innerHeight * 0.35,
      (trackH - window.innerHeight) * REVEAL_PORTION
    );

    if (window.scrollY + window.innerHeight < storyTopDoc - window.innerHeight * 0.5) {
      return 0;
    }

    return clamp01((window.scrollY - settleY) / dist);
  }

  function render() {
    const active = progress > 0;

    story.classList.toggle('is-can-settled', active);
    overlay?.classList.toggle('is-can-settled', active);
    overlay?.setAttribute('aria-hidden', active ? 'false' : 'true');

    callouts.forEach((el, i) => {
      const t = calloutReveal(i);
      reveals[i] = t;
      el.style.setProperty('--reveal', t.toFixed(4));
      el.classList.toggle('is-active', t >= INTERACTIVE_AT);
    });

    overlay?.style.setProperty('--eyebrow-reveal', clamp01(progress / EYEBROW_END).toFixed(4));
    overlay?.style.setProperty('--copy-reveal', clamp01((progress - COPY_START) / (1 - COPY_START)).toFixed(4));
    const copyReady = progress >= 0.8;
    overlay?.classList.toggle('is-copy-ready', copyReady);
    if (copyCta) {
      copyCta.inert = !copyReady;
      copyCta.tabIndex = copyReady ? 0 : -1;
    }

    interactive = progress >= INTERACTIVE_AT;

    if (active) {
      ensureLines();
      startTicking();
      updateLines();
    } else {
      updateLines();
    }
  }

  function onScroll() {
    progress = readScrub();
    render();
  }

  function bindCursor() {
    if (!callouts.length) return;

    window.addEventListener('pointermove', (e) => {
      if (!interactive) return;
      const px = e.clientX;
      const py = e.clientY;

      callouts.forEach((el, i) => {
        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width * 0.5;
        const cy = rect.top + rect.height * 0.5;
        const dx = px - cx;
        const dy = py - cy;
        const dist = Math.hypot(dx, dy);
        const radius = 260;
        const strength = Math.max(0, 1 - dist / radius);
        const pull = strength * strength * 18;

        if (dist > 0.001 && strength > 0) {
          magnets[i].x = (dx / dist) * pull;
          magnets[i].y = (dy / dist) * pull;
        } else {
          magnets[i].x = 0;
          magnets[i].y = 0;
        }
      });
    }, { passive: true });

    const resetMagnets = () => {
      magnets.forEach((m) => {
        m.x = 0;
        m.y = 0;
      });
    };

    window.addEventListener('pointerup', resetMagnets, { passive: true });
    window.addEventListener('blur', resetMagnets);

    callouts.forEach((el, i) => {
      const setHover = (on) => {
        el.classList.toggle('is-hovered', on);
        lineEls[i]?.classList.toggle('is-hovered', on);
      };
      el.addEventListener('pointerenter', () => setHover(true));
      el.addEventListener('pointerleave', () => setHover(false));
      el.addEventListener('focus', () => setHover(true));
      el.addEventListener('blur', () => setHover(false));
    });
  }

  story.addEventListener('stack-can-settle', onScroll);

  ensureLines();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  bindCursor();
  onScroll();
})();
